export default __webpack_public_path__ + "0c824945ad79b7886872cb36651681d0.png";